export const frameworks = [
  {
    name: "next.js",
    experience: "7 years",
    rate: 5,
  },
  {
    name: "react.js",
    experience: "7 years",
    rate: 5,
  },
  {
    name: "angular.js",
    experience: "7 years",
    rate: 5,
  },
  {
    name: "vue.js",
    experience: "3 years",
    rate: 5,
  },
  {
    name: "node.js",
    experience: "7 years",
    rate: 5,
  },
  {
    name: "react-native",
    experience: "4 years",
    rate: 3,
  },
  {
    name: "flutter",
    experience: "5 years",
    rate: 2,
  },
  {
    name: "swiftUI",
    experience: "2 years",
    rate: 2,
  },

  {
    name: "express.js",
    experience: "5 years",
    rate: 2,
  },
  {
    name: "electron.js",
    experience: "1 year",
    rate: 1,
  },
];
